import { mergeAttributes } from '@tiptap/core'
import TiptapParagraph from '@tiptap/extension-paragraph'

export const Paragraph = TiptapParagraph.extend({
	renderHTML({ HTMLAttributes }) {
		return [
			`p`,
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
				class: 'p-tt !mb-0',
			}),
			0,
		]
	},
	addKeyboardShortcuts() {
		return {
			Enter: () => {
				return false
			},
		}
	},
})

export default Paragraph
